import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import shared from '../../../utils/shared';
import AlbuquerqueAttractLoop from './AlbuquerqueAttractLoop';
import { FULLSCREEN, SCREEN, SCREENS_NUMBER } from './AlbuquerqueConstants';

class AlbuquerqueContainer extends Component {
  constructor(props) {
    super(props);

    try {

      const type = _.get(props.rootFolder, 'contents.custom_fields.folder_type.val.value', "fullscreen");
      const rootFolderId = _.get(props, 'rootFolder.id', null);  
      const tree = shared.createFolderTree(
        this.props.content.story_categories,
        this.props.content.folder_modules,
        this.props.rootFolder,
        this.props.content.stories,
        this.props.content.dm_active,
        rootFolderId,
        'rank',
        'desc'
      );
      
      // const attractLoop = tree.children.find(c => _.get(c, 'contents.custom_fields.folder_type.val.value', null) === "attract_loop");
      this.state = { tree, type }
    } catch(e) {
      console.log(e);
    }

  }

  getRenderedContent = () => {
    let content;
    switch (this.state.type) {
      case FULLSCREEN:
        content = this.getRenderedScreens();
        break;
      case SCREEN:
        content = this.getRenderedAttractLoop();
        break;
      default:
        break;
    }

    return content;
  }

  getRenderedAttractLoop = () => {
    try {
      let attractLoop = this.state.tree.find(c => _.get(c, 'contents.custom_fields.folder_type.val.value', null) === "attract_loop");
      attractLoop.children = _.orderBy(attractLoop.children, ['rank'], ['asc']);
      return (
        <div style={{ position: "absolute", width: this.props.screen.screenWidth, height: this.props.screen.screenHeight }}>
          <AlbuquerqueAttractLoop
            tree={attractLoop}
            content={this.props.content}
            donors={this.props.donors}
            width={this.props.screen.screenWidth}
            height={this.props.screen.screenHeight}
            screen={this.props.screen}
          />;
        </div>
      )
    } catch(e) {
      console.log(e);
    }
  }

  getRenderedScreens = () => {
    try {
      let screens = [];
      for (let i in this.state.tree) {
        const left = this.props.screen.screenWidth / SCREENS_NUMBER * i;
        let attractLoop = this.state.tree[i].children.find(c => _.get(c, 'contents.custom_fields.folder_type.val.value', null) === "attract_loop");
        attractLoop.children = _.orderBy(attractLoop.children, ['rank'], ['asc']);
        if (attractLoop) {
          screens.push(
            <div key={i} style={{ position: "absolute", width: this.props.screen.screenWidth /  3, height: this.props.screen.screenHeight, left }}>
              <AlbuquerqueAttractLoop
                tree={attractLoop}
                content={this.props.content}
                donors={this.props.donors}
                width={this.props.screen.screenWidth / SCREENS_NUMBER}
                height={this.props.screen.screenHeight}
                screen={this.props.screen}
              />
            </div>
          );
        }
      }  
      return screens;
    } catch(e) {
      console.log(e);
    }
  }

  render() {
    const renderedContent = this.getRenderedContent();
    try {
      return (
        <div>
          {renderedContent}
        </div>
      );
    } catch(e) {
      console.log(e);
    }
  }
}

const mapStateToProps = (state) => {
  const rootFolderId = _.get(state.content, 'settings.selected_root_folder', null);
  const rootFolder = state.content.story_categories.find(f => f.id === Number(rootFolderId));
  return {
    content: state.content,
    donors: state.donors,
    screen: state.screen,
    rootFolder: rootFolder
  };
};

export default connect(mapStateToProps, null)(AlbuquerqueContainer);


// WEBPACK FOOTER //
// ./src/Components/Theme/Albuquerque/AlbuquerqueContainer.jsx